// 状态 10：待审核 20：待补充资料 30：待支付 40：补办中 50：待收货 60：完结 70：已取消
export const NameplateReissueOrderStatusColorMap = new Map([
  [10, 'rgba(247, 152, 28, 1)'],
  [20, 'rgba(248, 83, 89, 1)'],
  [30, 'rgba(247, 152, 28, 1)'],
  [40, 'rgba(247, 152, 28, 1)'],
  [50, 'rgba(247, 152, 28, 1)'],
  [60, '#39B54A'],
  [70, 'rgba(0, 0, 0, 0.22)'],
])

export const NameplateReissueOrderStatusTextMap = new Map([
  [10, '待审核'],
  [20, '待补充资料'],
  [30, '待支付'],
  [40, '补办中'],
  [50, '待收货'],
  [60, '已收货'],
  [70, '已取消'],
])

// 服务类型：1. 付费； 2：免费
export const NameplateReissueOrderSerciceTypeTextMap = new Map([
  [1, '付费服务：'],
  [2, '免费服务'],
])

export const NameplateReissueOrderButtonTextMap = new Map([
  [50, '确认收货'],
  [30, '支付订单'],
])

export const NameplateReissueOrderDetailButtonTextMap = new Map([
  [50, '确认收货'],
  [30, '支付订单'],
  [20, '重新提交'],
])
